import translations from '../../components/location/ts/en-US';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('en-US', translations);
